import { CardContainer } from "@msys/ui";
import { Typography } from "@mui/material";
import { Stack } from "@mui/system";
import React from "react";

export function SectionCard({
  title,
  titleAdornment,
  children,
}: {
  title: string;
  titleAdornment?: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <CardContainer>
      <Stack
        spacing={1}
        sx={{
          p: 1,
        }}
      >
        <Stack
          direction="row"
          spacing={0.5}
          sx={{
            alignItems: "center",
          }}
        >
          <Typography variant="button" sx={{ py: "2px" }}>
            {title}
          </Typography>
          {titleAdornment}
        </Stack>
        {children}
      </Stack>
    </CardContainer>
  );
}
